import { render, staticRenderFns } from "./ChangeImg.vue?vue&type=template&id=5237417a&scoped=true&"
import script from "./ChangeImg.vue?vue&type=script&lang=js&"
export * from "./ChangeImg.vue?vue&type=script&lang=js&"
import style0 from "./ChangeImg.vue?vue&type=style&index=0&id=5237417a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237417a",
  null
  
)

export default component.exports